export default {
  path: '/selos-virtuais',
  component: () => import('@/components/pages/VirtualSeals/VirtualSeals.vue')
}
